import React from "react";
import Image from "next/image";

type ServicesCRMCardProps = {
  backgroundImage: string;
  title: string;
  description: string;
  isOpen?: boolean;
  onToggle?: () => void;
};

const ServicesCrmCardMobile: React.FC<ServicesCRMCardProps> = ({
  title,
  description,
  backgroundImage,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="relative overflow-hidden flex flex-row group">
      <div
        className="shadow-[0px_12.68px_57.07px_-7.93px_#001A2D3D] overflow-hidden relative group h-[600px] w-full min-w-[390px] card-hover-img"
      >
        {backgroundImage ? (
          <Image
            src={backgroundImage}
            alt="industry bg"
            width={810}
            height={600}
            quality={100}
            className="w-full xl:h-auto md:h-[600px] h-[600px] max-h-full object-cover object-center transition-all duration-300 scale-100 ease-in-out group-hover:scale-[1.1] group-focus-within:scale-100"
          />
        ) : (
          <div className="w-full xl:h-auto md:h-[600px] h-[600px] max-h-full bg-[#E6EAF0]" />
        )}
        <span className="bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,#000000_100%)] absolute top-auto bottom-0 right-0 w-full h-full"></span>

        <div className="absolute bottom-0 left-0 py-[26px] max-w-[680px] px-5">
          <h3 className="text-heading-5 font-bold text-primary-text-white mb-[12px]">
            {title}
          </h3>

          <a
            // href="#!"   // there won't be any link as per discussion with Praveen bhai and Samir bhai
            className="text-primary-text-white py-[16px_14px] flex items-center"
            onClick={onToggle}
          >
            More Info
            <Image
              height={16}
              width={16}
              src="/images/crm/info-circle.png"
              alt=""
              className="ms-2 mt-0.5 min-w-[16] max-h-[16px]"
            />
          </a>
        </div>
      </div>

      {isOpen && (
        <div className="flex sm:relative absolute group-hover:sm:flex xl:w-[620px] md:w-[420px] w-[calc(100%-0)] justify-end xl:ml-[0] flex-col bg-white sm:h-[600px] h-[510px] p-[24px] border-[0.34px] border-[var(--Border,#E6F5FF)]">
          <p className="text-heading-6 font-semibold text-primary-text mt-2">
            {description}
          </p>

          <div className="w-6 h-7 bg-white [clip-path:polygon(0_50%,100%_0,100%_100%)] z-40 absolute sm:left-[-20px] left-[110px] sm:rotate-0 rotate-150 sm:bottom-[40px] bottom-[-15px]"></div>
        </div>
      )}
    </div>
  );
};
export default ServicesCrmCardMobile;
